export default {
    methods: {

        handleGA4AddToCart() {
          let item = {
            'item_id': this.item.id,
            'item_name': this.item.title,
            'item_category': this.item.vehicle_group.label,
            'price': this.prices.per_day,
            'quantity': 1,
          };
          if (!lodash.isNil(this.locationId)) {
            item.location_id = this.locationId;
          }
          //location_id
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            'event': 'add_to_cart',
            'ecommerce': {
              'currency': 'EUR',
              'value': this.prices.per_day,
              'items': [item],
            },
          })
        },

        handleAnalyticsBeginCheckout() {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                'event': 'begin_checkout',
                'currency': 'EUR',
                'items': [{
                    'item_id': `${this.id}`,
                    'item_name': `${this.item.title}`,
                }]
            })
        },

        handleAnalyticsStopCheckout() {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                'event': 'remove_from_cart',
                'ecommerce': {
                    'currency': 'EUR',
                    'value': this.getVehicleRates[0].price,
                    'items': [
                        {
                            'item_id': this.getActiveVehicle.id,
                            'item_name': this.getActiveVehicle.title,
                            'item_category': this.getActiveVehicle.vehicle_group.label,
                            'item_category2': this.getDays,
                            'location_id': this.getActiveLocation.id,
                            'price': this.getTotalVehicleRates,
                        },
                    ],
                },
            });
        },

        handleAnalyticsViewItem() {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                'event': 'view_item',
                'items': [{
                    'item_id': `${this.id}`,
                    'item_name': `${this.item.title}`
                }]
            })
        }
    }
}
